"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RebateType = exports.CommissionType = exports.ShareCodeUpdateType = void 0;
var ShareCodeUpdateType;
(function (ShareCodeUpdateType) {
    ShareCodeUpdateType["update_remark"] = "update_remark";
    ShareCodeUpdateType["set_default"] = "set_default";
})(ShareCodeUpdateType || (exports.ShareCodeUpdateType = ShareCodeUpdateType = {}));
var CommissionType;
(function (CommissionType) {
    CommissionType["RETAIN"] = "RETAIN";
    CommissionType["REBATE"] = "REBATE";
})(CommissionType || (exports.CommissionType = CommissionType = {}));
var RebateType;
(function (RebateType) {
    RebateType["PERPETUAL_BOT"] = "PERPETUAL_BOT";
    RebateType["PERPETUAL"] = "PERPETUAL";
    RebateType["SPOT"] = "SPOT";
    RebateType["LEVERAGE_TOKEN"] = "LEVERAGE_TOKEN";
    RebateType["ARBITRAGE"] = "ARBITRAGE";
    RebateType["DUAL"] = "DUAL";
})(RebateType || (exports.RebateType = RebateType = {}));
